// Theme JavaScript
class JimmyRoweTheme {
  constructor() {
    this.init();
  }

  init() {
    this.initMobileMenu();
    this.initCart();
    this.initProductCards();
    this.initProductPage();
  }

  initMobileMenu() {
    const menuToggle = document.querySelector('.header__mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const menuClose = document.querySelector('.mobile-menu__close');

    if (menuToggle) {
      menuToggle.addEventListener('click', () => {
        mobileMenu?.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    if (menuClose) {
      menuClose.addEventListener('click', () => {
        mobileMenu?.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close menu when clicking outside
    if (mobileMenu) {
      mobileMenu.addEventListener('click', (e) => {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  }

  initCart() {
    // Update cart count
    this.updateCartCount();

    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });

    // Handle cart item removal
    this.initCartItemRemoval();
  }

  initCartItemRemoval() {
    const removeButtons = document.querySelectorAll('.cart-item__remove');
    removeButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        const line = button.getAttribute('data-line');
        
        if (line && confirm('Remove this item from cart?')) {
          // Show loading state
          button.disabled = true;
          button.textContent = 'Removing...';
          
          const result = await AjaxCart.updateItem(parseInt(line), 0);
          if (result.success) {
            // Reload to show updated cart
            location.reload();
          } else {
            alert('Error removing item: ' + (result.error || 'Unknown error'));
            button.disabled = false;
            button.textContent = 'Remove';
          }
        }
      });
    });

    // Handle quantity updates
    const quantityInputs = document.querySelectorAll('.cart-item__quantity-input');
    quantityInputs.forEach(input => {
      let timeout;
      const originalValue = input.value;
      
      input.addEventListener('input', (e) => {
        clearTimeout(timeout);
        
        // Debounce the update
        timeout = setTimeout(async () => {
          const line = input.getAttribute('data-line');
          const quantity = parseInt(input.value);
          
          if (line && !isNaN(quantity) && quantity >= 0) {
            if (quantity === 0) {
              if (confirm('Remove this item from cart?')) {
                input.disabled = true;
                const result = await AjaxCart.updateItem(parseInt(line), 0);
                if (result.success) {
                  location.reload();
                } else {
                  alert('Error removing item: ' + (result.error || 'Unknown error'));
                  input.disabled = false;
                  input.value = originalValue;
                }
              } else {
                input.value = originalValue; // Reset to original if cancelled
              }
            } else if (quantity !== parseInt(originalValue)) {
              // Only update if quantity actually changed
              input.disabled = true;
              const result = await AjaxCart.updateItem(parseInt(line), quantity);
              if (result.success) {
                // Update the original value
                input.defaultValue = quantity;
                input.disabled = false;
                // Optionally reload to get updated prices
                location.reload();
              } else {
                alert('Error updating quantity: ' + (result.error || 'Unknown error'));
                input.disabled = false;
                input.value = originalValue; // Reset on error
              }
            }
          } else {
            input.value = originalValue; // Reset invalid input
          }
        }, 500); // Wait 500ms after user stops typing
      });
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch(window.routes.cart_url + '.js');
      const cart = await response.json();
      const cartCount = cart.item_count || 0;
      
      const cartBadge = document.querySelector('.header__cart-badge');
      if (cartBadge) {
        if (cartCount > 0) {
          cartBadge.textContent = cartCount;
          cartBadge.style.display = 'flex';
        } else {
          cartBadge.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  initProductCards() {
    const productCards = document.querySelectorAll('.product-card');
    
    productCards.forEach(card => {
      card.addEventListener('click', (e) => {
        const link = card.querySelector('a');
        if (link && !e.target.closest('.product-card__badge')) {
          window.location.href = link.href;
        }
      });
    });
  }

  initProductPage() {
    // Product image thumbnail switching
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const mainImage = document.querySelector('[data-product-image]');
    
    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          // Remove active class from all thumbnails
          thumbnails.forEach(t => t.classList.remove('active'));
          // Add active class to clicked thumbnail
          thumbnail.classList.add('active');
          
          // Update main image
          const imageUrl = thumbnail.getAttribute('data-image-url');
          const imageSrcset = thumbnail.getAttribute('data-image-srcset');
          
          if (imageUrl) {
            mainImage.srcset = imageSrcset || imageUrl;
            mainImage.src = imageUrl;
          }
        });
      });
    }

    // Product variant selection
    const variantSelects = document.querySelectorAll('.product-form__option-select');
    const variantIdInput = document.getElementById('product-variant-id');
    const productForm = document.getElementById('product-form');
    
    if (variantSelects.length > 0 && variantIdInput && productForm) {
      // Get product data from meta tag or data attribute
      const productDataScript = document.querySelector('script[type="application/json"][data-product]');
      let productData = null;
      
      if (productDataScript) {
        try {
          productData = JSON.parse(productDataScript.textContent);
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }

      // Fallback: fetch variant data from form
      if (!productData) {
        // Use form submission to get variant - simpler approach
        variantSelects.forEach(select => {
          select.addEventListener('change', () => {
            // Let the form handle variant selection naturally
            const formData = new FormData(productForm);
            // Shopify will handle variant selection on form submit
          });
        });
      } else {
        function updateVariant() {
          const selectedOptions = Array.from(variantSelects).map(select => select.value);
          const variant = productData.variants.find(v => {
            return v.options.every((option, index) => option === selectedOptions[index]);
          });

          if (variant && variantIdInput) {
            variantIdInput.value = variant.id;
            
            // Update price
            const priceElement = document.querySelector('.product-page__price-current');
            if (priceElement) {
              const price = (variant.price / 100).toFixed(2);
              priceElement.textContent = '$' + price;
            }

            // Update availability
            const submitButton = productForm.querySelector('.product-form__submit');
            if (submitButton) {
              if (variant.available) {
                submitButton.disabled = false;
                submitButton.querySelector('span').textContent = 'Add to cart';
              } else {
                submitButton.disabled = true;
                submitButton.querySelector('span').textContent = 'Sold out';
              }
            }
          }
        }

        variantSelects.forEach(select => {
          select.addEventListener('change', updateVariant);
        });
      }
    }

    // Handle form submission with AJAX
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const submitButton = productForm.querySelector('.product-form__submit');
        const originalText = submitButton.querySelector('span').textContent;
        
        // Disable button and show loading state
        submitButton.disabled = true;
        submitButton.querySelector('span').textContent = 'Adding...';
        
        const formData = new FormData(productForm);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        if (variantId) {
          try {
            const result = await AjaxCart.addItem(parseInt(variantId), parseInt(quantity));
            
            if (result.success) {
              // Show success message
              submitButton.querySelector('span').textContent = 'Added to Cart!';
              submitButton.style.background = '#28a745';
              
              // Reset button after 2 seconds
              setTimeout(() => {
                submitButton.querySelector('span').textContent = originalText;
                submitButton.style.background = '';
                submitButton.disabled = false;
              }, 2000);
            } else {
              // Show error message
              alert('Error: ' + (result.error || 'Failed to add product to cart. Please try again.'));
              submitButton.querySelector('span').textContent = originalText;
              submitButton.disabled = false;
            }
          } catch (error) {
            console.error('Form submission error:', error);
            alert('An error occurred. Please try again.');
            submitButton.querySelector('span').textContent = originalText;
            submitButton.disabled = false;
          }
        } else {
          alert('Please select a variant');
          submitButton.disabled = false;
        }
      });
    }
  }
}

// Initialize theme when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new JimmyRoweTheme();
  });
} else {
  new JimmyRoweTheme();
}

// AJAX Cart functionality
class AjaxCart {
  static async addItem(variantId, quantity = 1) {
    try {
      // Use FormData approach which is more reliable with Shopify
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        body: formData
      });

      // Check if response is actually JSON
      const contentType = response.headers.get('content-type') || '';
      
      if (contentType.includes('application/json')) {
        const data = await response.json();
        
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return { success: true, data };
        } else {
          throw new Error(data.description || data.message || 'Failed to add item to cart');
        }
      } else {
        // If we get HTML, try to parse it or redirect to cart
        const text = await response.text();
        
        // If it's a redirect or HTML, the item was likely added successfully
        // Shopify sometimes returns HTML for cart_add_url
        if (response.ok || response.status === 200 || response.status === 302) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return { success: true, data: { message: 'Item added to cart' } };
        }
        
        console.error('Non-JSON response received:', text.substring(0, 200));
        throw new Error('Unable to add item to cart. Please try again or visit the cart page.');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      return { success: false, error: error.message };
    }
  }

  static async updateItem(line, quantity) {
    try {
      // Use FormData approach which is more reliable with Shopify
      const formData = new FormData();
      formData.append('line', line);
      formData.append('quantity', quantity);

      const response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        body: formData
      });

      // Check if response is actually JSON
      const contentType = response.headers.get('content-type') || '';
      
      if (contentType.includes('application/json')) {
        const data = await response.json();
        
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return { success: true, data };
        } else {
          throw new Error(data.description || data.message || 'Failed to update cart');
        }
      } else {
        // If we get HTML, try to parse it or reload cart
        const text = await response.text();
        
        // If it's a redirect or HTML, the update was likely successful
        // Shopify sometimes returns HTML for cart_change_url
        if (response.ok || response.status === 200 || response.status === 302) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return { success: true, data: { message: 'Cart updated' } };
        }
        
        console.error('Non-JSON response received:', text.substring(0, 200));
        throw new Error('Unable to update cart. Please try again.');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      return { success: false, error: error.message };
    }
  }
}

// Make AjaxCart available globally
window.AjaxCart = AjaxCart;
